module.exports = __webpack_public_path__ + "media/bootstrap-icons/crop-e502aea7.svg";